export default __webpack_public_path__ + "static/media/blueprint.22bbeb50.png";